export interface UserSummary {
  id: number;
  firstName: string;
  lastName: string;
  email: string;
  phone: string;
  point: number;
  taxOffice?: string;
  taxNumber?: string;
}

export const userSummaryFromResponse = (responseData: any): UserSummary => ({
  id: responseData.id,
  firstName: responseData.first_name ?? '',
  lastName: responseData.last_name ?? '',
  email: responseData.email,
  phone: responseData.phone ?? '',
  point: responseData.point,
  taxOffice: responseData.vergi_dairesi,
  taxNumber: responseData.vergi_no,
});
